<template>
  <div class="container header_block">
    <div class="row align-items-center">
      <div class="col header_block__logo">
        <img src="/images/logo.png" alt="logo">
        <span>VEO Lviv</span>
      </div>
      <div class="col">
        <div class="d-flex align-center justify-content-end">
          <change-locale/>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChangeLocale from "../small_components/ChangeLocale";
export default {
  name: "AuthHeaderBlock",
  components: {ChangeLocale},

}
</script>
